Object.defineProperty(exports, "__esModule", { value: true });

function max(bp) {
  let query = '';
  switch (bp) {
    case 'S':
      query = '(max-width: 719px)';
      break;
    case 'M':
      query = '(max-width: 959px)';
      break;
    case 'L':
      query = '';
      break;
    default:
      break;
  }
  return window.matchMedia(query).matches;
}

function min(bp) {
  let query = '';
  switch (bp) {
    case 'S':
      query = '';
      break;
    case 'M':
      query = '(min-width: 720px)';
      break;
      case 'L':
      query = '(min-width: 960px)';
      break;
    default:
      break;
  }
  return window.matchMedia(query).matches;
}

function is(bp) {
  let query = '';
  switch (bp) {
    case 'S':
      query = '(max-width: 719px)';
      break;
    case 'M':
      query = '(min-width: 720px) and (max-width: 960px)';
      break;
    case 'L':
      query = '(min-width: 960px)';
      break;
    default:
      break;
  }
  return window.matchMedia(query).matches;
}

exports.max = max;
exports.min = min;
exports.is = is;